import type { QuestionSavedAnalyticsPublic } from "@/client"
import { HtmlContent } from "@/components/Common/HtmlContent"
import {
  Badge,
  Box,
  Card,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react"

export function SavedQuestionActivityCard({
  activity,
}: {
  activity: QuestionSavedAnalyticsPublic
}) {
  return (
    <Card.Root>
      <Card.Body>
        <Stack gap={4}>
          <Heading size="md">Saved question activity</Heading>
          <SimpleGrid columns={{ base: 1, sm: 3 }} gap={3}>
            <Metric label="Saved entries" value={activity.saved_count} />
            <Metric label="Bookmarks" value={activity.bookmark_count} />
            <Metric label="Notes" value={activity.note_count} />
          </SimpleGrid>
          <Box>
            <Heading size="sm" mb={2}>
              Latest student notes
            </Heading>
            {activity.recent_notes.length === 0 ? (
              <Text color="fg.muted">No student notes yet.</Text>
            ) : (
              <Stack gap={3}>
                {activity.recent_notes.map((note, index) => (
                  <Box
                    key={`${note.quiz_id}-${note.updated_at}-${index}`}
                    bg="bg.subtle"
                    borderRadius="md"
                    p={3}
                  >
                    <Flex justify="space-between" gap={2} wrap="wrap" mb={2}>
                      <Badge>{note.quiz_name}</Badge>
                      <Text fontSize="sm" color="fg.muted">
                        {note.student_name ||
                          note.student_email ||
                          "Anonymous student"}
                      </Text>
                    </Flex>
                    <HtmlContent content={note.note_html} />
                  </Box>
                ))}
              </Stack>
            )}
          </Box>
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}

function Metric({ label, value }: { label: string; value: number }) {
  return (
    <Box bg="bg.subtle" borderRadius="md" p={3}>
      <Text fontSize="2xl" fontWeight="bold">
        {value}
      </Text>
      <Text fontSize="sm" color="fg.muted">
        {label}
      </Text>
    </Box>
  )
}
